const tabBarHeight = 48
const appBarHeight = 64

export const topPadding = tabBarHeight + appBarHeight
